import React from 'react'
import ScrollTo from './ScrollTo'

const ScrollToTop = ({ doScroll }) => <ScrollTo y={0} doScroll={doScroll} />

export default ScrollToTop
